import { render, staticRenderFns } from "./ServiceSearchResultRow.vue?vue&type=template&id=55d23982"
import script from "./ServiceSearchResultRow.vue?vue&type=script&lang=js"
export * from "./ServiceSearchResultRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports